import {
    Component,
    Output,
    Input,
    EventEmitter,
    ViewChild,
    ElementRef,
    AfterViewInit,
    OnDestroy,
    inject,
} from '@angular/core';
import {DxTreeViewModule, DxTreeViewComponent, DxTreeViewTypes} from 'devextreme-angular/ui/tree-view';
import * as events from 'devextreme/events';
import {MenuItem, navigation} from '../../../app-navigation';
import {AuthService} from "@services";

@Component({
    selector: 'side-navigation-menu',
    templateUrl: './side-navigation-menu.component.html',
    styleUrls: ['./side-navigation-menu.component.scss'],
    imports: [DxTreeViewModule],
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
    @ViewChild(DxTreeViewComponent, {static: true})
    menu!: DxTreeViewComponent;

    @Output()
    selectedItemChanged = new EventEmitter<DxTreeViewTypes.ItemClickEvent>();

    @Output()
    openMenu = new EventEmitter<any>();

    @Input()
    get compactMode() {
        return this._compactMode;
    }

    @Input()
    set selectedItem(value: String) {
        this._selectedItem = value;
        this.setSelectedItem();
    }

    get selectedItem(): String {
        return this._selectedItem;
    }

    set compactMode(val) {
        this._compactMode = val;

        if (!this.menu.instance) {
            return;
        }

        if (val) {
            this.menu.instance.collapseAll();
        } else {
            this.menu.instance.expandItem(this._selectedItem);
        }
    }

    private _selectedItem!: String;

    private _items!: Record<string, unknown>[];

    private _compactMode = false;

    private elementRef = inject(ElementRef);
    private authService = inject(AuthService);

    get items() {
        if (!this._items) {
            this._items = navigation.map((item) => {
                if (item.path && !(/^\//.test(item.path))) {
                    item.path = `/${item.path}`;
                }

                if (item.items) {
                    item.items = item.items.filter((subItem: MenuItem) => {
                        return this.isAuthorized(subItem);
                    });
                }

                if (this._compactMode) {
                    return {...item, expanded: false};
                }

                return {...item};
            }).filter((item: any) => {
                const hasPermission = this.isAuthorized(item);
                const hasChildren = !item.items || item.items.length > 0;

                return hasPermission && hasChildren;
            });
        }

        return this._items;
    }

    private isAuthorized(item: MenuItem): boolean {
        return this.authService.isMenuItemAuthorized(item);
    }

    setSelectedItem() {
        if (!this.menu.instance) {
            return;
        }

        this.menu.instance.selectItem(this.selectedItem);
        this.expandSelectedItemSection();
    }

    private expandSelectedItemSection() {
        if (!this._selectedItem || this._compactMode) {
            return;
        }

        const selectedPath = this._selectedItem.toString();
        const section = (this.items as MenuItem[]).find(item =>
            item.items?.some(child => child.path === selectedPath));

        if (section) {
            this.menu.instance.expandItem(section);
        }
    }

    onItemClick(event: DxTreeViewTypes.ItemClickEvent) {
        this.selectedItemChanged.emit(event);
    }

    ngAfterViewInit() {
        this.setSelectedItem();
        events.on(this.elementRef.nativeElement, 'dxclick', (e: Event) => {
            this.openMenu.next(e);
        });
    }

    ngOnDestroy() {
        events.off(this.elementRef.nativeElement, 'dxclick');
    }
}
